import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Check, Plus } from "lucide-react";
import { euro, imgSrc } from "@/lib/api";

const COPY = {
  patch: { title: "Patch occhi", desc: "Un trattamento intensivo da abbinare al tuo contorno occhi: patch pronti all'uso, compatibili con il tuo profilo." },
  boost: { title: "Potenzia il trattamento", desc: "Patch viso e device da abbinare al tuo trattamento: un boost mirato in più, non un prodotto della routine né un'alternativa." },
  tonepad: { title: "Potenzia con un pad", desc: "Tonici in formato pad, già imbevuti, da alternare al tuo tonico: un gesto in più mirato e pratico, non un'alternativa." },
  device: { title: "Potenzia il risultato", desc: "Beauty device che amplificano l'efficacia di questo step. Un investimento in più, non un prodotto della routine." },
};
const pairing = (p, kind, stepProduct) => p.how_text || (kind === "boost" && /patch/i.test(p.name)
  ? `Applica i patch sulla zona da trattare 2–3 volte a settimana, la sera dopo ${stepProduct || "il tuo trattamento"}, e lasciali agire come indicato.`
  : kind === "patch"
  ? `Applica i patch 2–3 volte a settimana prima di ${stepProduct || "il tuo contorno occhi"}: un boost intensivo per lo sguardo.`
  : kind === "tonepad"
  ? `Passa un pad su viso pulito 2–3 sere a settimana al posto di ${stepProduct || "il tuo tonico"}, poi prosegui con la routine. Nelle altre sere continua con il tonico.`
  : `Usalo subito dopo ${stepProduct || "il prodotto di questo step"}: aiuta gli attivi a penetrare meglio e amplifica il risultato.`);

export const AddonsSheet = ({ open, onClose, entry, products, extras, onToggle, stepProduct }) => {
  const copy = COPY[entry?.addon_kind] || COPY.device;
  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="bottom" className="bg-[#FAF8F5] max-h-[85vh] overflow-y-auto rounded-t-2xl border-[#E6DFD5]" data-testid="addons-sheet">
        {entry && (
          <div className="max-w-2xl mx-auto w-full pb-6">
            <SheetHeader className="text-left">
              <p className="fs-eyebrow">{entry.step_name} · in più</p>
              <SheetTitle className="font-serif text-3xl font-normal">{copy.title}</SheetTitle>
              <SheetDescription className="text-sm text-[#8C8275]">{copy.desc}</SheetDescription>
            </SheetHeader>
            <ul className="mt-6 divide-y divide-[#E6DFD5]">
              {entry.addon_ids.map((id) => {
                const p = products[id];
                if (!p) return null;
                const added = extras.includes(id);
                return (
                  <li key={id} className="py-5 flex gap-4 items-center" data-testid={`addon-item-${id}`}>
                    <div className="w-16 h-20 bg-[#F2ECE4] shrink-0 overflow-hidden">
                      {p.image && <img src={imgSrc(p.image)} alt={p.name} className="w-full h-full object-cover" />}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[10px] tracking-[0.2em] uppercase text-[#8C6F3E] mb-1">{p.brand}</p>
                      <p className="font-serif text-lg leading-tight">{p.name}</p>
                      <p className="text-xs text-[#595652] mt-1.5 leading-relaxed" data-testid={`addon-pairing-${id}`}>
                        <span className="text-[10px] tracking-[0.18em] uppercase text-[#8C6F3E]">Come abbinarlo · </span>{pairing(p, entry.addon_kind, stepProduct?.name)}
                      </p>
                      <p className="text-sm mt-1.5 tabular-nums">{euro(p.price)}</p>
                    </div>
                    <button data-testid={`toggle-addon-btn-${id}`} className={`${added ? "fs-btn" : "fs-btn-ghost"} !px-4 !py-3`} onClick={() => onToggle(id)} aria-pressed={added}>
                      {added ? <><Check size={14} strokeWidth={1.5} /> Aggiunto</> : <><Plus size={14} strokeWidth={1.5} /> Aggiungi</>}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
